export default "__VITE_PUBLIC_ASSET__8000a848__"